import { createAction, props } from '@ngrx/store';
import { INotifyIndividualRequest } from '../models/notify-individual-request.model';
import { INotifyIndividualResponse } from '../models/notify-individual-response.model';

export const notifyIndividualOutstanding = createAction(
  '[Outstanding] Notify Individual Outstanding',
  props<{
    request: INotifyIndividualRequest;
  }>()
);

export const notifyIndividualOutstandingSuccess = createAction(
  '[Outstanding] Notify Individual Outstanding Success',
  props<{ response: string }>()
);

export const notifyIndividualOutstandingFailure = createAction(
  '[Outstanding] Notify Individual Outstanding Failure',
  props<{ error: Error | any }>()
);
